// @flow
/** @jsx jsx */
/* eslint-disable jsx-a11y/label-has-associated-control */

import { useState } from 'react';

import { jsx } from '@emotion/core';
import { BooleanInput, Icon, TruncatedText } from '@zapier/common-components';
import { Border, Colors } from '@zapier/theme';

import ZapMoverZap from 'app/zap-mover/components/FilterableZapsList/ZapMoverZap';

import type {
  FolderType,
  OnChooseFolderType,
  OnChooseZapType,
} from 'app/zap-mover/types';

type Props = {
  ...$Exact<FolderType>,
  isOpen: boolean,
  isSingleSelect: boolean,
  onChooseFolder: OnChooseFolderType,
  onChooseZap: OnChooseZapType,
};

const isZapSelected = zap => zap.isSelected;
const padding = '15px';

const folderCss = {
  '&:not(:last-of-type)': {
    borderBottom: `${Border.size.default} solid ${Colors.storm}`,
  },
};

const headerCss = {
  alignItems: 'center',
  display: 'flex',
  padding,
};

const labelCss = {
  alignItems: 'center',
  cursor: 'pointer',
  display: 'flex',
  flex: 1,
  marginRight: '1em',
};

const titleCss = {
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  fontSize: '1.5rem',
  fontWeight: 600,
  lineHeight: 1.4,
  marginLeft: '1em',
  minWidth: 0,
  padding: 0,
  textTransform: 'none',
  userSelect: 'none',
};

const zapListCss = {
  margin: `5px ${padding} 5px 50px`,
};

const zapListItemCss = {
  marginBottom: 18,
};

const ZapMoverFolder = (props: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  const hasZaps = props.zaps.length > 0;
  const isSomeZapSelected = props.zaps.some(isZapSelected);
  const isEveryZapSelected = props.zaps.every(isZapSelected);

  const zaps =
    isOpen || props.isOpen ? (
      <ul css={zapListCss}>
        {props.zaps.map(zap => (
          <li css={zapListItemCss} key={zap.id}>
            <ZapMoverZap
              {...zap}
              isSingleSelect={props.isSingleSelect}
              onChoose={props.onChooseZap}
            />
          </li>
        ))}
      </ul>
    ) : null;

  return (
    <section css={folderCss}>
      <header css={headerCss}>
        <label
          css={labelCss}
          onClick={props.isSingleSelect ? () => setIsOpen(!isOpen) : undefined}
        >
          <BooleanInput
            checked={hasZaps && isEveryZapSelected}
            disabled={props.isSingleSelect}
            indeterminate={hasZaps && isSomeZapSelected && !isEveryZapSelected}
            onChange={({ checked, value }) =>
              props.onChooseFolder(checked, value)
            }
            type={props.isSingleSelect ? 'radio' : 'checkbox'}
            value={props.id}
          />
          <span css={titleCss}>
            <TruncatedText block={true}>{props.title}</TruncatedText>
          </span>
        </label>
        {!props.isOpen && (
          <Icon
            color="steel"
            name={isOpen ? 'arrow-up' : 'arrow-down'}
            onClick={() => setIsOpen(!isOpen)}
          />
        )}
      </header>
      {zaps}
    </section>
  );
};

export default ZapMoverFolder;
